import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import Lottie from "lottie-react";
import Loader from "../../animation/Loader.json";
import { fetchApi } from "../../utlis/axios";
import { toast } from "react-toastify";
import { FaChevronDown, FaSearch } from "react-icons/fa";
import Pagination from "../../ListingPage/Pagination";
import { IoMdClose } from "react-icons/io";
import { FiTrash2 } from "react-icons/fi";

export const FamilyProgram = () => {
  const [programData, setProgramData] = useState([]);
  const { id } = useSelector((state) => state.authSlice.userInfo?.user);
  const { access } = useSelector((state) => state.authSlice.userInfo);
  const [searchQuery, setSearchQuery] = useState("");
  const [isLoading, setIsLoading] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedFamilies, setSelectedFamilies] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [rowId, setRowId] = useState("");
  const [selectedFamiliesInModal, setSelectedFamiliesInModal] = useState([]);
  const [familyModel, setFamilyModel] = useState();
  const [allFamilies, setAllFamilies] = useState([]);
  const [modal, setModal] = useState(false);
  const [isCheck, setIsCheck] = useState(false);
  const [allProgram, setAllProgram] = useState([]);
  const [formValues, setFormValues] = useState({
    budget: "",
    year: "",
    program: "",
    family: [],
  });
  const [validationErrors, setValidationErrors] = useState({
    budget: "",
    year: "",
    program: "",
    family: [],
  });

  const getFamilyProgramData = async () => {
    setIsLoading(true);
    try {
      const result = await fetchApi.get(`sub-programs/?search=${searchQuery}`, {
        headers: {
          Authorization: `Bearer ${access}`,
        },
      });
      if (result.status === 200) {
        setProgramData(result?.data);
        console.log("result data.......", result?.data);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.log({ error });
    }
  };

  useEffect(() => {
    getFamilyProgramData();
  }, [searchQuery, access]);

  useEffect(() => {
    const fetchAllFamilies = async () => {
      try {
        const result = await fetchApi.get(
          "family/?status=accepted&limit=1000",
          {
            headers: {
              Authorization: `Bearer ${access}`,
            },
          }
        );
        if (result.status === 200) {
          setAllFamilies(result.data);
          console.log("All familes...///", result.data);
        }
      } catch (error) {
        console.error("Error fetching all families:", error);
      }
    };
    fetchAllFamilies();
  }, [access]);

  const toggle = () => {
    setModal(!modal);
    setIsCheck(true);
    setFormValues({
      budget: "",
      year: "",
      program: "",
      family: [],
    });
  };

  const handleTableRowClick = (id) => {
    console.log("id", id);
    setRowId(id);
  };

  const handleViewButtonClick = (families) => {
    setSelectedFamilies(families);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setSelectedFamilies([]);
    setShowModal(false);
  };

  const handleCloseFamilyModel = () => {
    setFamilyModel(false);
  };

  const showFamilyModel = () => {
    setShowModal(false);
    setFamilyModel(true);
  };

  const itemsPerPage = 10;
  const totalPages = Math.ceil(programData.count / itemsPerPage);

  const fetchDataForPage = async (pageNumber) => {
    const newOffset = (pageNumber - 1) * itemsPerPage;

    try {
      const result = await fetchApi.get(
        `sub-programs/?limit=${itemsPerPage}&offset=${newOffset}&page=${pageNumber}&pageSize=${itemsPerPage}&search=${searchQuery}`,
        {
          headers: {
            Authorization: `Bearer ${access}`,
          },
        }
      );

      return result;
    } catch (error) {
      throw error;
    }
  };

  const handlePageClick = (pageNumber) => {
    console.log("pageNumbber", pageNumber);
    if (pageNumber !== currentPage) {
      setCurrentPage(pageNumber);
      setIsLoading(true);

      // Fetch data for the selected page
      fetchDataForPage(pageNumber)
        .then((result) => {
          if (result.status === 200) {
            setProgramData(result?.data);
            // console.log("family data....", familyData)
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  const nextPageData = async () => {
    const nextPage = currentPage + 1;
    const newOffset = (nextPage - 1) * itemsPerPage;

    setIsLoading(true);

    try {
      const result = await fetchApi.get(
        `sub-programs/?limit=${itemsPerPage}&offset=${newOffset}&page=${nextPage}&pageSize=${itemsPerPage}&search=${searchQuery}`,
        {
          headers: {
            Authorization: `Bearer ${access}`,
          },
        }
      );

      if (result.status === 200) {
        setProgramData(result?.data);
        console.log("next data", result.data.results);
        setCurrentPage(nextPage);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const prevPageData = async () => {
    const prevPage = currentPage - 1;
    const newOffset = (prevPage - 1) * itemsPerPage;

    setIsLoading(true);

    try {
      const result = await fetchApi.get(
        `sub-programs/?limit=${itemsPerPage}&offset=${newOffset}&page=${prevPage}&pageSize=${itemsPerPage}&search=${searchQuery}`,
        {
          headers: {
            Authorization: `Bearer ${access}`,
          },
        }
      );

      if (result.status === 200) {
        setProgramData(result?.data);
        setCurrentPage(prevPage);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteFamily = async (familyId) => {
    // Remove the family from selectedFamilies
    const updatedFamilies = selectedFamilies.filter(
      (family) => family.id !== familyId
    );
    setSelectedFamilies(updatedFamilies);
    // Send a PATCH request to update the data on the server
    try {
      const result = await fetchApi.patch(
        `sub-programs/${rowId}/`,
        {
          family: updatedFamilies.map((family) => family.id),
        },
        {
          headers: {
            Authorization: `Bearer ${access}`,
          },
        }
      );

      if (result.status === 200) {
        console.log("Family id removed");
      }
      getFamilyProgramData();
    } catch (error) {
      console.error("Error deleting family:", error);
    }
  };

  const handleFamilySelectionInModal = (familyId) => {
    const isSelected = selectedFamiliesInModal.includes(familyId);
    if (isSelected) {
      // If the family is already selected, remove it
      setSelectedFamiliesInModal(
        selectedFamiliesInModal.filter((id) => id !== familyId)
      );
    } else {
      // If the family is not selected, add it
      setSelectedFamiliesInModal([...selectedFamiliesInModal, familyId]);
    }
  };

  const handleSaveSelectedFamiliesInModal = async () => {
    try {
      // Filter out the IDs of the previously selected families that are not in the selectedFamiliesInModal array
      const previousFamilyIds = selectedFamilies
        .filter((family) => !selectedFamiliesInModal.includes(family.id))
        .map((family) => family.id);

      // Combine the previously selected family IDs with the IDs of the newly selected families
      const familyIds = [...previousFamilyIds, ...selectedFamiliesInModal];

      // Send a PATCH request to update the families associated with the program
      const result = await fetchApi.patch(
        `sub-programs/${rowId}/`,
        {
          family: familyIds,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${access}`,
          },
        }
      );

      if (result.status === 200) {
        console.log("Selected families saved successfully.");
        setFamilyModel(false);
        setShowModal(false);
        getFamilyProgramData();
        window.location.reload();
      }
    } catch (error) {
      console.error("Error saving selected families:", error);
    }
  };

  const GetAllProgram = async () => {
    try {
      const result = await fetchApi.get("programs/", {
        headers: {
          Authorization: `Bearer ${access}`,
        },
      });
      if (result.status === 200) {
        setAllProgram(result?.data);
      }
    } catch (error) {
      console.log({ error });
    }
  };

  useEffect(() => {
    GetAllProgram();
  }, []);

  const validateForm = () => {
    let valid = true;
    const errors = {
      budget: "",
      year: "",
      program: "",
    };

    if (!formValues.budget) {
      valid = false;
      errors.budget = "Budget is required";
    }

    if (!formValues.year) {
      valid = false;
      errors.year = "year is required";
    }

    if (!formValues.program) {
      valid = false;
      errors.program = "program is required";
    }

    setValidationErrors(errors);
    return valid;
  };

  const createProgram = async () => {
    if (!validateForm()) {
      return;
    }

    try {
      const data = new FormData();
      data.append("id", id);
      data.append("budget", formValues?.budget);
      data.append("year", formValues?.year);
      data.append("program", formValues?.program);
      data.append("is_active", true);
      if (formValues.family.length > 0) {
        // Append the family array directly to the FormData object
        formValues.family.forEach((familyId, index) => {
          data.append("family", [familyId]);
        });
      }

      const result = await fetchApi.post("sub-programs/", data, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${access}`,
        },
      });

      if (result?.status === 201) {
        console.log("posted program");
        setModal(false);
      }

      getFamilyProgramData();
    } catch (error) {
      console.error("Error in createProgram:", error);
      toast.error(error?.response?.data?.detail);
    }
  };

  return (
    <div className="w-full px-[16px] md:px-10 min-h-screen mt-16 max-w-screen-xl mx-auto">
      {/* Top Section */}
      <h1 className="md:text-4xl text-2xl font-bold capitalize mb-4">
        Sub-Programs
      </h1>
      <div className="flex items-center justify-between gap-3 mt-6 md:mb-8 mb-3">
        {/* Search */}
        <div className="relative flex justify-center border rounded-full sm:py-2 py-1 px-2 sm:w-[400px] w-full bg-[#FCFBF7] items-center gap-2">
          <FaSearch className="text-gray-500" />
          <input
            type="search"
            name="search"
            className="w-full outline-none text-gray-600 sm:py-2 py-[4px] px-1 bg-transparent"
            placeholder="Search here...."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>

        {/* Add Family Button */}
        <div className="Tbtn">
          <span
            className="primary-button sm:text-base text-sm font-medium"
            onClick={toggle}
          >
            Add Sub-Program
          </span>
        </div>
      </div>

      {/* Table Section */}
      <div className="overflow-x-auto bg-white rounded-[20px] border border-gray-border">
        <table className="min-w-full border-collapse">
          <thead>
            <tr className="bg-primary-green text-white text-left">
              <th className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs sm:text-sm font-semibold md:text-base whitespace-nowrap">
                Program
              </th>
              <th className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs sm:text-sm font-semibold md:text-base whitespace-nowrap ">
                Budget
              </th>
              <th className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs sm:text-sm font-semibold md:text-base whitespace-nowrap">
                Year
              </th>
              <th className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs sm:text-sm font-semibold md:text-base whitespace-nowrap">
                Family
              </th>
            </tr>
          </thead>

          <tbody className="">
            {isLoading ? (
              <tr>
                <td colSpan={4} className="h-[60vh]">
                  <div className="flex justify-center items-center h-full w-full">
                    <Lottie
                      loop={true}
                      animationData={Loader}
                      style={{ width: "200px" }}
                      className="auth-sidebar-video"
                    />
                  </div>
                </td>
              </tr>
            ) : programData?.results?.length > 0 ? (
              programData?.results?.map((data, index) => (
                <tr
                  key={index}
                  className={`cursor-pointer ${
                    index % 2 === 0 ? "bg-white" : "bg-[#219D8014]"
                  } hover:bg-gray-200`}
                  onClick={() => handleTableRowClick(data?.id)}
                >
                  <td className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs font-normal md:text-base whitespace-nowrap truncate">
                    {data?.program?.name}
                  </td>
                  <td className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs font-normal md:text-base whitespace-nowrap truncate">
                    {data?.budget}
                  </td>
                  <td className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs font-normal md:text-base whitespace-nowrap truncate">
                    {data?.year}
                  </td>
                  <td className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs font-normal md:text-base whitespace-nowrap truncate">
                    <span
                      className=" px-3 py-1 rounded-full text-primary-green border-2 border-primary-green"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleViewButtonClick(data?.family);
                      }}
                    >
                      View
                    </span>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={4} className="p-4 text-center">
                  No items found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="flex justify-center items-center mt-6">
        <Pagination
          currentPage={currentPage}
          handlePageClick={handlePageClick}
          totalPages={totalPages}
        />
      </div>

      {/* Create Program Modal */}
      <div className="flex items-center justify-center h-full">
        {isCheck && (
          <div className="fixed inset-0 z-[100] flex justify-center ">
            {/* backdrop */}
            <div
              className="absolute inset-0 bg-black/50"
              onClick={() => setIsCheck(false)}
            ></div>

            {/* modal wrapper */}
            <div className="flex items-center justify-center overflow-y-auto w-full min-h-screen py-8 md:py-16 px-[16px] sm:px-4">
              <div className="relative z-[200] w-full max-w-lg my-auto">
                <div className="bg-[#FCFBF7] rounded-3xl shadow-xl">
                  {/* Close button */}
                  <button
                    className="absolute w-max top-4 right-4 text-gray-700 bg-primary-green/10 p-1 rounded-full cursor-pointer  text-black                      hover:text-gray-700 text-2xl"
                    onClick={() => setIsCheck(false)}
                  >
                    <IoMdClose />
                  </button>

                  {/* Header */}
                  <div className="sm:mx-6 mx-[16px] pt-6 pb-3 border-b border-[#444444]">
                    <h2 className="text-3xl font-bold text-gray-800">
                      Create Sub-Programm
                    </h2>
                  </div>

                  <div className=" pt-3 pb-2 sm:px-6 px-[16px]">
                    <form>
                      <div className="form-group">
                        <label
                          htmlFor="recipient-name"
                          className="col-form-label"
                        >
                          Budget:
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          id="recipient-name"
                          style={{
                            borderRadius: "10px",
                            height: "3rem",
                            background: "transparent",
                            border: "1px solid #444444",
                          }}
                          value={formValues?.budget}
                          onChange={(e) =>
                            setFormValues({
                              ...formValues,
                              budget: e.target.value,
                            })
                          }
                        />
                        <span className="error-message text-danger">
                          {validationErrors.budget}
                        </span>
                      </div>
                      <div className="form-group">
                        <label
                          htmlFor="recipient-name"
                          className="col-form-label"
                        >
                          Year:
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          id="recipient-name"
                          style={{
                            borderRadius: "10px",
                            height: "3rem",
                            background: "transparent",
                            border: "1px solid #444444",
                          }}
                          value={formValues?.year}
                          onChange={(e) =>
                            setFormValues({
                              ...formValues,
                              year: e.target.value,
                            })
                          }
                        />
                        <span className="error-message text-danger">
                          {validationErrors.year}
                        </span>
                      </div>
                      <div className="form-group">
                        <label
                          htmlFor="recipient-name"
                          className="col-form-label"
                        >
                          Program:
                        </label>
                        <div className="relative">
                        <select
                          type="text"
                          id="program"
                          name="program"
                          placeholder="program"
                          className="formField custom-select relative"
                          value={formValues?.program}
                          onChange={(e) =>
                            setFormValues({
                              ...formValues,
                              program: e.target.value,
                            })
                          }
                          style={{
                            width: "100%",
                            borderRadius: "10px",
                            height: "3rem",
                            background: "transparent",
                            border: "1px solid #444444",
                          }}
                          required
                        >
                          <option>Select</option>
                          {allProgram?.results?.map((item) => {
                            return (
                              <option value={item?.id}>{item?.name}</option>
                            );
                          })}
                          
                       
                        </select>
                        
                        <FaChevronDown size={16} className="text-gray-400 absolute right-[5%] top-[30%]"/>
                        </div>
                        <span className="error-message text-danger">
                          {validationErrors.description}
                        </span>
                      </div>
                      <div className="form-group">
                        <label
                          htmlFor="recipient-name"
                          className="col-form-label"
                        >
                          Family:
                        </label>
                        <select
                          id="family"
                          name="family"
                          className="formField "
                          value={formValues?.family}
                          onChange={(e) =>
                            setFormValues({
                              ...formValues,
                              family: Array.from(
                                e.target.selectedOptions,
                                (option) => option.value
                              ),
                            })
                          }
                          style={{
                            width: "100%",
                            borderRadius: "10px",
                            background: "transparent",
                            border: "1px solid #444444",
                          }}
                          required
                          multiple // Add multiple attribute here
                        >
                          {allFamilies?.results?.map((item) => {
                            return (
                              <option value={item?.id}>{item?.name}</option>
                            );
                          })}
                        </select>
                        <span className="error-message text-danger">
                          {validationErrors.family}
                        </span>
                      </div>
                    </form>
                  </div>
                  <div className="sm:px-6 px-[16px] sm:py-3 py-[8px]">
                    <div className="flex w-full justify-start">
                      <button
                        onClick={createProgram}
                        className="font-quicksand primary-button sm:w-[30%] w-full"
                      >
                        Create
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Family Details Modal */}
      {showModal && (
        <Modal
          show={showModal}
          onHide={handleCloseModal}
          centered
          style={{ margin: "auto" }}
        >
          <button
            className="p-1 text-black shadow-none bg-[#edf7f5] rounded-full w-max absolute top-4 right-4"
            onClick={() => setShowModal(false)}
          >
            <IoMdClose size={24} />
          </button>
          <Modal.Header>
            <Modal.Title className="!font-bold !text-2xl">
              Family Details
            </Modal.Title>
          </Modal.Header>

          <Modal.Body
            style={{
              padding: "10px 20px",
              borderBottom: "1px solid #d8d8d8 !important",
            }}
          >
            <div style={{ border: "1px solid #d8d8d8", borderRadius: "12px" }}>
              {/* Header Table */}
              <div
                style={{
                  overflow: "hidden",
                  borderBottom: "1px solid #d8d8d8",
                  borderRadius: "12px 12px 0 0",
                }}
              >
                <table
                  style={{
                    width: "100%",
                    margin: 0,
                    borderCollapse: "collapse",
                    borderSpacing: 0,
                  }}
                >
                  <thead>
                    <tr
                      style={{
                        backgroundColor: "#219d80",
                        color: "white",
                      }}
                    >
                      <th
                        style={{
                          padding: "12px",
                          textAlign: "left",
                          width: "70%",
                          fontWeight: "600",
                        }}
                      >
                        Family Name
                      </th>
                      <th
                        style={{
                          padding: "12px",
                          textAlign: "left",
                          width: "30%",
                          fontWeight: "600",
                        }}
                      >
                        Action
                      </th>
                    </tr>
                  </thead>
                </table>
              </div>

              {/* Body Table */}
              <div
                style={{
                  maxHeight: "350px",
                  overflowY: "auto",
                  borderRadius: "0 0 12px 12px",
                }}
              >
                <table
                  style={{
                    width: "100%",
                    margin: 0,
                    borderCollapse: "collapse",
                    borderSpacing: 0,
                  }}
                >
                  <tbody>
                    {selectedFamilies.map((family, index) => (
                      <tr
                        key={index}
                        style={{
                          backgroundColor:
                            index % 2 !== 0 ? "#219d8014" : "#ffffff",
                        }}
                      >
                        <td
                          style={{
                            padding: "12px",
                            width: "70%",
                            borderBottom: "1px solid #e5e5e5",
                          }}
                        >
                          {family.name}
                        </td>
                        <td
                          style={{
                            padding: "12px",
                            width: "30%",
                            borderBottom: "1px solid #e5e5e5",
                          }}
                        >
                          <button
                            className="bg-transparent shadow-none w-max text-red-500"
                            style={{ width: "100%" }}
                            onClick={() => handleDeleteFamily(family.id)}
                          >
                            <FiTrash2 size={20} />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </Modal.Body>
          <hr className="m-0" />
          <Modal.Footer
            style={{
              background: "white !important",
              borderTop: "1px solid #d8d8d8 !important",
            }}
          >
            {/* Add Button */}
            <div className="w-full flex justify-center">
              <button
                className="!w-[80%] mx-auto !font-quicksand font-bold primary-button"
                onClick={showFamilyModel}
              >
                Add Family
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      )}
      {/* Select Families Modal */}
      <Modal show={familyModel} onHide={handleCloseFamilyModel}>
        <Modal.Header
          style={{ display: "block", position: "relative", borderBottom: "0" }}
        >
          <button
            className="p-1 text-black bg-[#edf7f5] rounded-full w-max absolute top-4 right-4"
            onClick={handleCloseFamilyModel}
          >
            <IoMdClose size={24} />
          </button>
          <Modal.Title style={{ fontWeight: 700, fontSize: "28px" }}>
            Select Families
          </Modal.Title>
        </Modal.Header>
        <hr className="mx-3 my-0" />
        <Modal.Body>
          <div className="border-[1px] border-gray-border rounded-xl overflow-hidden">
            <div className="w-full bg-primary-green text-white sm:p-4 p-[10px]">
              Family
            </div>
            <div
              style={{
                maxHeight: "350px",
                overflowY: "auto",
              }}
            >
              {allFamilies?.results?.map((family, index) => (
                <div
                  key={family.id}
                  className={`cursor-pointer sm:px-4 px-[8px] sm:py-[12px] py-[8px] flex justify-between ${
                    index % 2 === 0 ? "bg-white" : "bg-[#219D8014]"
                  } hover:bg-gray-200`}
                >
                  <label className="">{family.name}</label>
                  {selectedFamiliesInModal.includes(family.id) ? (
                    <button
                      className="px-2 py-1 rounded-full text-primary-green bg-transparent shadow-none w-max"
                      style={{ border: "2px solid #219d80" }}
                      onClick={() => handleFamilySelectionInModal(family.id)}
                    >
                      Added
                    </button>
                  ) : (
                    <button
                      className="border-[2px] border-primary-green bg-transparent w-max rounded-full px-2.5 py-1 text-primary-green font-medium shadow-none"
                      style={{ border: "2px solid #219d80" }}
                      onClick={() => handleFamilySelectionInModal(family.id)}
                    >
                      Add
                    </button>
                  )}
                </div>
              ))}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer
          style={{
            borderTop: "1px solid #d8d8d8 !important",
            background: "#ffffff",
          }}
        >
          <button
            style={{ width: "80%" }}
            className="mx-auto primary-button"
            onClick={handleSaveSelectedFamiliesInModal}
          >
            Save
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
